<template>
    <v-container>
        <h2>{{$t('students_to_transferred_me1')}} {{$t('students_to_transferred_me2')}}</h2>
        <v-layout class="my-4" calign-center>
            <v-flex>
                <v-card class="elevation-5">
                    <v-card-text>
                        <v-layout row wrap class="my-4" calign-center justify-center fill-height>
                            <v-flex xs12>
                                <v-data-table
                                    :headers="headers3"
                                    :items="dataListStudents"
                                    :single-select="singleSelect"
                                    item-key="id"
                                    class="elevation-1"
                                    :no-data-text="$t('no_transfer_students')"
                                    hide-default-footer
                                    :items-per-page="-1"
                                    :loading="loadingDataStudentsTransferred"
                                >
                                  <template v-slot:item.avatar="{ item }">
                                    <v-avatar
                                        class="profile"
                                        color="grey"
                                        size="50"
                                    >
                                      <v-img :src="item.avatar">
                                      </v-img>
                                    </v-avatar>
                                  </template>
                                  <template v-slot:item.status="{ item }">
                                    <v-tooltip v-if="item.status > 0" bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            color="primary"
                                            class="mr-2"
                                            disabled
                                        >
                                          <v-icon>mdi-check</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>{{$t('attended')}}</span>
                                    </v-tooltip>
                                  </template>
                                  <template v-slot:item.id="{ item }">
                                    <div v-if="item.status === 3 && getProfile.express_check_out === false">
                                      <v-btn
                                          color="primary"
                                          @click="signExitPass(item.idStudent, item.id_classroom)"
                                      >
                                        {{$t('sign_exit')}}
                                      </v-btn>
                                    </div>
                                    <div v-if="item.status === 3 && getProfile.express_check_out === true">
                                      <v-btn
                                          color="green"
                                          :loading="loading"
                                          @click="createExpressExit(item.idStudent)"
                                      >
                                        {{$t('registrar_salidas')}}
                                      </v-btn>
                                    </div>
                                    <div v-if="item.status === 1">
                                      <v-icon color="green">mdi-check</v-icon>
                                      {{$t('signed')}}
                                    </div>
                                    <div v-if="item.status === 2">
                                      {{$t('out_of_school')}}
                                    </div>
                                  </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import {mapGetters, mapState} from "vuex"

export default {
  name: "transferred_students",
  data () {
    return {
      loading: false,
      dialogSendList: false,
      classroomsXTeacher: [],
      loadingDataStudentsTransferred: false,
      headers: [],
      dataListStudents: [],
      selected: [],
      studentsSelectedToTransfer: [],
      attendance: [],
      dialogListStudentSignExitPass: false,
      dataListStudentsToSignExitPass: [],
      singleSelect: false,
      headers3: [],
      teachers: [],
      idTeacher: null,
      errores: [],
      AreThereStudentsAttendance: false
    }
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
  },
  beforeUpdate () {
        this.headers3 = [
          {
            text: this.$t('photo'),
            align: 'center',
            sortable: false,
            value: 'avatar'
          },
          {
            text: this.$t('Apellido'),
            align: 'left',
            sortable: false,
            value: 'last_name'
          },
          {
            text: this.$t('Nombre'),
            align: 'left',
            sortable: false,
            value: 'first_name'
          },
          {
            text: this.$t('attended'),
            align: 'center',
            sortable: false,
            value: 'status'
          },
          {
            text: this.$t('estado'),
            align: 'center',
            sortable: false,
            value: 'id'
          }
        ]
  },
  created() {
    this.getStudentsTransferred ()
  },
  methods: {
    getStudentsTransferred () {
      this.loadingDataStudentsTransferred = true
      HTTP.get('transferred/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response.data)
        this.dataListStudents = response.data
        this.loadingDataStudentsTransferred = false
      })
      .catch(error => {
        this.loadingDataStudentsTransferred = false
        console.log(error)
      })
    },
    signExitPass(uuidStudent, idClassroom) {
      var student = []

      student.push({
        'idStudent': uuidStudent
      })
      HTTP.patch('classroom/' + idClassroom + '/list/sign_pass/',
        student,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('sign_pass_success'))
        this.getStudentsTransferred()
        // setTimeout(this.clear, 3000)
      })
      .catch(error => {
        console.log(error)
      })
    },
    createExpressExit(uuidStudent) {
      this.loading = true
      var student = []

      student.push({
        'idStudent': uuidStudent
      })
      HTTP.post('express_exit/',
        student,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      // .then(ok => {
      //   this.loading = false
      //   console.log(ok)
      //   this.$store.commit('snackbar_activate_true')
      //   this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
      //   this.getStudentsTransferred()
      //   // setTimeout(this.clear, 3000)
      // })
      // .catch(error => {
      //   this.loading = false
      //   console.log(error)
      // })

      // console.log(ok)
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
      setTimeout(this.clear, 1000)
    },
    clear () {
      this.getStudentsTransferred()
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>

</style>
